import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "body" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "button"
}
const _hoisted_4 = {
  key: 1,
  class: "center"
}
const _hoisted_5 = { class: "mobileButton" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.deviceImage,
        alt: ""
      }, null, 8, _hoisted_2),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              type: "primary",
              class: "pc",
              onClick: _ctx.goToPage,
              round: ""
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("請登入註冊")
              ])),
              _: 1,
              __: [0]
            }, 8, ["onClick"])
          ]))
        : (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "mobile",
                  onClick: _ctx.goToPage,
                  round: ""
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("請登入註冊")
                  ])),
                  _: 1,
                  __: [1]
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("img", {
      src: _ctx.bottomImage,
      alt: ""
    }, null, 8, _hoisted_6)
  ], 64))
}